import React, { useState } from 'react';
import { classNames } from '@utils/class-names';
import Logo from '@common/components/logo';

interface MobileHeaderProps {
  onMenuToggle: () => void;
  isMenuOpen: boolean;
}

const MobileHeader: React.FC<MobileHeaderProps> = ({ onMenuToggle, isMenuOpen }) => {
  return (
    <header className="lg:hidden mobile-header bg-surface-level-2 border-b border-outline-mild h-16 flex items-center justify-between px-4">
      <Logo />
      
      <button
        onClick={onMenuToggle}
        className={classNames(
          'p-2 rounded-lg hover:bg-surface-level-1 transition-colors duration-200',
          isMenuOpen ? 'hamburger-open' : ''
        )}
        aria-label="Toggle menu"
      >
        <div className="w-6 h-6 flex flex-col justify-center items-center">
          <span className="hamburger-line block w-5 h-0.5 bg-on-surface" />
          <span className="hamburger-line block w-5 h-0.5 bg-on-surface mt-1" />
          <span className="hamburger-line block w-5 h-0.5 bg-on-surface mt-1" />
        </div>
      </button>
    </header>
  );
};

export default MobileHeader;
